import { AxiosResponse } from 'axios';
import get from 'lodash/get';

import { getInstance } from './Instance';
import { Logger } from '../utils/logger';
import { InventoryGroup } from '../models/Inventory';
import { GetResponse } from '../models/Response';

export const Groups = async (): Promise<InventoryGroup[]> => {
  try {
    const response: AxiosResponse<GetResponse<InventoryGroup[]>> = await getInstance().get(
      '/v2/inv/group/list?includeStatistics=false&noOfEntries=0&provideAccountLevelExcludedGroup=false',
    );
    return get(response, 'data.responseObject', []);
  } catch (e) {
    Logger.log('Error while getting inventory group list', e);
    return [];
  }
};
